import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CrudService } from '../crud.service';
import { DataLayerType } from '../../models/data-layer-type';

@Injectable({
  providedIn: 'root',
})
export class DataLayerTypeService extends CrudService<DataLayerType> {
  protected basePath = 'dataLayerType'; // Specific for DataLayerTypeService
  public instanceType = 'dataLayerType'; // Used in base service for constructing URLs

  constructor(http: HttpClient) {
    super(http);
  }
}
